'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const hasFunctionNameInCallstack = (funcName) => {
    try {
        throw new Error('work around error to get call stack');
    }
    catch (e) {
        const { stack } = e;
        if (!stack) {
            return false;
        }
        return stack.includes(funcName);
    }
};

exports["default"] = hasFunctionNameInCallstack;
